<template>
  <div id="checkout-cta-container" class="checkout-cta-container">
    <div :class="['d-flex justify-content-between total-container', hideTotal]">
      <div class="label-total-price">
        <span v-html="$t('label.total.price')"></span> {{ " " }}
        <span class="total-price-formatted">
          {{ " " + cart.totals.grandTotal }}
        </span>
      </div>
      <span v-if="!cart.isGratisEmployee && !cart.isFreshEmployee && isThisCartPage" @click="activatePromoCode"
        class="btn btn-link label-add-promo-code"><span v-html="$t('label.add.promo.code')"></span></span>
    </div>
    <a :href="`${actionURLs[checkoutBtnLink]}`" :class="`begin-checkout-btn ${isCheckoutDisabled ? 'disabled' : ''}`"
      @click="beginCheckout($event)">
      <span v-if="isThisCartPage" class="text">
        <span v-html="$t('button.checkout')"></span></span>
      <span v-else class="text">
        <span v-html="$t('button.viewbag')"></span></span>

      <img v-if="isThisCartPage" class="lock-icon" :src="svgIcon('checkout-lock-icon')" aria-hidden="true" />
    </a>
    <div v-show="isExpressPaymentEnabled" class="express-payment-container r-legacy-express-payment-container">
      <isapplepay
        class="dw-apple-pay-button dw-apple-pay-logo-white express-payment-btn apple-btn"
      >
      </isapplepay>

      <PayPal v-if="isAdyenPPExpressEnabled" />

      <div v-if="isKlarnaExpressEnabled" class="klarna-express">
        <klarna-express-button ref="klarnaExpressButton" :data-locale="locale.replace('_', '-')" data-theme="light"
          data-label="klarna"></klarna-express-button>
      </div>

      <div @click="doNothing" v-if="isGoogleEnabled" class="express-payment-btn">
        <img class="payment-svg" :src="svgIcon('google-pay-logo')" />
      </div>

      <div @click="doNothing" v-if="isVenmoEnabled" class="express-payment-btn">
        <img class="payment-svg" :src="svgIcon('venmo-pay-logo')" />
      </div>
    </div>
    <div v-if="isExpressPaymentEnabled && enableGDPR" class="gdpr-payment-label"
      v-html="$t('content.asset.gdpr.payment.label')"> </div>
  </div>
</template>

<script>
import PayPal from '@/components/PayPal.vue';
import { EventBus } from "@/scripts/event-bus.js";
import { mapState, mapGetters } from "vuex";
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";
import { ref } from "vue";
export default {
  name: "CheckoutCTAContainer",
  components: {
    PayPal,
  },
  setup() {
    const klarnaExpressButton = ref(null);
    const { vueVariables } = vue3_mapGetters();
    return {
        vueVariables,
        klarnaExpressButton
    }
  },
  data() {
    return {
      enableGDPR: window.vue.customPreferences.enableGDPR,
      isGoogleEnabled: false,
      isVenmoEnabled: false,
      paths: window.vue.paths,
      locale: this.vueVariables.locale,
      klarnaMID: window.vue.customPreferences.klarnaMID,
      klarnaEnvironment: window.vue.customPreferences.klarnaEnvironment,
      globaleEnabled: window.vue.customPreferences.globaleEnabled
    };
  },
  computed: {
    isCustomerAuthenticated: function () {
      return this.vueVariables.isCustomerAuthenticated;
    },
    isExpressPaymentEnabled: function () {
      return !this.isSOREnabled && !this.cart.isGratisEmployee && !this.cart.isFreshEmployee && !this.cart.valid.error
    },

    checkoutBtnLink: function () {
      let link = "Cart-Show";

      if (this.isThisCartPage && this.globaleEnabled) {
        link = this.isCustomerAuthenticated ? "Checkout-Begin" : "Checkout-Login";
      } else if (this.isThisCartPage) {
        link = "Checkout-Login";
      }

      return link;
    },

    hideTotal: function () {
      return this.isThisCartPage ? "d-md-none" : "";
    },

    isThisCartPage: function () {
      return window.vueCurrentActiveStates['cart'] ? true : false;
    },

    isAdyenPPExpressEnabled: function () {
      return this.vueVariables.adyenPreferences && this.vueVariables.adyenPreferences.ppExpressEnabled;
    },

    isKlarnaExpressEnabled: function () {
      return window.vue.customPreferences.klarnaExpressEnabled;
    },

    ...mapState([
      "actionURLs"
    ]),

    areProductsOutOfStock: function () {
      return this.cart.items.some(
        (item) => item.available == false || item.hasInventory == false
      );
    },

    areProductsWithMaxQuantityExceed: function () {
      return this.cart.items.some(
        (item) => item.quantity > item.quantityOptions.maxOrderQuantity
      );
    },
    ...mapGetters({
      cart: "cart",
      checkout: "checkout",
      checkoutLogin: "checkoutLogin",
      isSOREnabled: "isSOREnabled"
    }),
    svgIcon() {
      return (iconName) =>
        `${this.vueVariables.staticImagesFolder}/${iconName}.svg`;
    },

    isCheckoutDisabled() {
      return (this.isThisCartPage && this.cart.valid.error) || (this.isCustomerAuthenticated ? (this.isThisCartPage && Object.values(this.checkout).length === 0) : (this.isThisCartPage && (Object.values(this.checkout).length === 0 || Object.values(this.checkoutLogin).length === 0)))
    },
  },
  methods: {
    adjustFooterPadding() {
      if (!this.isExpressPaymentEnabled) {
        return;
      }

      document.getElementById('common-footer').classList.add('express-payment-enabled');
    },

    activateKlarna() {
      if (this.isKlarnaExpressEnabled) {
        if (this.isThisCartPage || document.readyState === 'complete') {
          this.addKlarnaButtons();
        } else {
          window.addEventListener('load', this.addKlarnaButtons);
        }
      }
    },

    beginCheckout(event) {
      if (this.isThisCartPage) {
        event.preventDefault();
        if (!this.isCheckoutDisabled) {
          localStorage.setItem('beginCheckout', false);

          if (this.areProductsOutOfStock || this.areProductsWithMaxQuantityExceed) {
            this.scrollToElementById(this.areProductsOutOfStock ? "out-of-stock-warning" : "max-quantity-warning");
          }
          if (this.isCustomerAuthenticated && this.globaleEnabled) {
            window.location.href = window.vue.actionURLs['Checkout-Begin'];
          } else if (this.isCustomerAuthenticated) {
            document.dispatchEvent(new CustomEvent('route-to', { detail: '/checkout' }));
            // this.$router.push(this.paths['/checkout']);
          } else {
            EventBus.$emit("showCheckoutLogin");
            // document.dispatchEvent(new CustomEvent('route-to', { detail: '/checkout-login' }));
            // this.$router.push(this.paths['/checkout-login']);
          }
        }
      }
    },

    activatePromoCode() {
      this.scrollToPromoCode();
    },

    outerHeight(element, thisHeight, margins) {
      const height = thisHeight,
        style = window.getComputedStyle(element);

      return margins
        .map((side) => parseInt(style[`margin-${side}`]))
        .reduce((total, side) => total + side, height);
    },

    scrollToElementById(elementId) {
      let element = document.getElementById(elementId);
      let header = document.getElementById("header");
      let headerOffset = this.outerHeight(header, header.offsetHeight, [
        "top",
        "bottom",
      ]);
      let elementPosition = element.getBoundingClientRect().top;
      let elementOffset = this.outerHeight(element, 0, ["bottom"]);
      let offsetPosition =
        elementPosition + window.pageYOffset - headerOffset - elementOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },

    scrollToPromoCode() {
      let element = document.getElementById("promo-code-container");
      let stickyCheckoutCTA = document.getElementById("checkout-cta-container");

      window.scrollTo({
        top:
          element.offsetTop -
          window.innerHeight +
          // promo-code-opened height
          140 +
          stickyCheckoutCTA.offsetHeight,
        behavior: "smooth",
      });
      this.delay(1000).then(() => EventBus.$emit("activatePromoCode"));
    },
    doNothing() { },

    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },

    addKlarnaButtons() {
      if (!this.klarnaExpressButton) {
        throw 'Element not rendered';
      }
      this.$loadScript(
        'https://x.klarnacdn.net/express-button/v1/lib.js', {
        'data-id': this.klarnaMID,
        'data-environment': this.klarnaEnvironment,
      }, {}
      ).then(() => {
        Klarna.ExpressButton.refreshButtons();
        setTimeout(function () {
          var style = document.createElement('style');
          style.innerHTML = '#klarna-express-button { min-width: unset; } .keb-light#klarna-express-button { border-color: #000; }';
          this.klarnaExpressButton.shadowRoot.appendChild(style);
          this.klarnaExpressButton.classList.add('loaded');
        }.bind(this), 100);
        this.klarnaExpressButton.addEventListener('click', () => {
          window.EventEmitter?.emit('beginExpressPayment', {
            checkoutType: 'Express:Klarna'
          });
        });
      })
        .catch(() => { });
    }
  },
  mounted() {
    this.activateKlarna();
    if (!window.checkoutCTAContainerListeners) {
      document.addEventListener("onActivatedCart", () => {
        this.activateKlarna();
      });
      window.checkoutCTAContainerListeners = true;
    }
  },
  updated() {
    this.adjustFooterPadding();
  }
};
</script>